export enum MerchantRole {
  Admin = 'Admin',
  AdminV3 = 'ApiV3 Admin',
  ReportingUser = 'Reporting User',
  WebManager = 'Web Manager',
}
